// extracted by mini-css-extract-plugin
module.exports =  {"logo":"HeaderLogotype-module__logo--xymD5","logoMini":"HeaderLogotype-module__logoMini--BrCpk","root":"HeaderLogotype-module__root--EF5zo"};